/* eslint-disable no-irregular-whitespace */
import React, { type ReactElement, memo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { preOverquotaBannerConfig } from 'reactApp/appHelpers/featuresHelpers/features/overquotaPre';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
import { InformationAlertBanner, InformationBannerType } from 'reactApp/ui/InformationAlertBanner/InformationAlertBanner';

import styles from './PreOverquotaBanner.css';
import { usePreOverquotaBannerCallbacks } from './PreOverquotaBanner.helpers';

export const PreOverquotaBanner = memo(function PreOverquotaBanner({
    setShow,
}: {
    setShow?: (value: boolean) => void;
}): ReactElement | null {
    const { used, userTotalSpace } = useSelector(UserQuotaSelectors.getUserQuotaState);
    const { onShowHandler, onPrimaryHandler, onSecondaryHandler, onCancelHandler } = usePreOverquotaBannerCallbacks({
        hide: () => {
            setShow?.(false);
        },
    });

    useEffect(() => {
        onShowHandler();
    }, []);

    return (
        <InformationAlertBanner
            title="Смотреть и загружать файлы скоро будет нельзя"
            content={
                <div className={styles.content}>
                    В едином пространстве Почты и Облака <span>{used?.space}</span> из <span>{userTotalSpace?.value}</span> — оно почти
                    переполнено. Увеличьте его с подпиской Mail Space
                </div>
            }
            closable={preOverquotaBannerConfig.closable}
            onCancel={onCancelHandler}
            primaryButtonTitle="Увеличить место"
            secondaryButtonTitle={(preOverquotaBannerConfig.secondButton?.enable && preOverquotaBannerConfig.secondButton?.name) || ''}
            type={InformationBannerType.alert}
            onPrimaryClick={onPrimaryHandler}
            onSecondaryClick={onSecondaryHandler}
        />
    );
});
